import { TextFieldWithPrefix, FieldProps, useFieldHelper } from 'framework/ui/field';
import { PlannedDateIcon } from 'framework/ui/mui-builder';
import { FC } from 'react';

const PlannedDateField: FC<FieldProps> = props => {
  const { getValue } = useFieldHelper<string>(props);
  const value = getValue();

  return (
    <TextFieldWithPrefix
      tooltipProps={{
        title: 'Planned date',
        children: (
          <div>
            <PlannedDateIcon />
          </div>
        ),
      }}
      label=""
      value={value}
    />
  );
};

export default PlannedDateField;
